import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { ConditionsStore, IAvailableCondition, IUserCondition } from './types'

export const useConditionsStore = create<ConditionsStore>()(
  devtools(() => ({
    getUserConditions: async (userId: number) => {
      try {
        const response = await http.get(`/user/${userId}/conditions`)

        return (response as IUserCondition[]) ?? []
      } catch (error) {
        console.error('Error fetching user conditions:', error)
        return []
      }
    },

    getAvailableConditions: async (userId: number) => {
      try {
        const response = await http.get(`/user/${userId}/conditions/available`)

        return (response as IAvailableCondition[]) ?? []
      } catch (error) {
        console.error('Error fetching available conditions:', error)
        return []
      }
    },

    addUserCondition: async (userId: number, conditionId: number) => {
      try {
        await http.post(`/user/${userId}/conditions`, {
          condition_id: conditionId
        })

        return true
      } catch (error) {
        console.error('Error adding user condition:', error)
        return false
      }
    },

    // the path takes the available condition id, not the user condition one
    removeUserCondition: async (userId: number, conditionId: number) => {
      try {
        await http.delete(`/user/${userId}/conditions/${conditionId}`)

        return true
      } catch (error) {
        console.error('Error removing user condition:', error)
        return false
      }
    }
  }))
)
